import { useEffect, useState } from "react";

type ViewportDimensions = {
  viewportHeight: number;
  viewportWidth: number;
};

export function useWindowDimensions(): ViewportDimensions {
  const [viewportDimensions, setViewportDimensions] =
    useState<ViewportDimensions>({
      viewportWidth: 0,
      viewportHeight: 0
    });

  const handleResize = () => {
    setViewportDimensions({
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight
    });
  };

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return viewportDimensions;
}
